import { Component, inject } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MenuService } from '../../../menu.service';
import { UserInformationService } from '../../../user-information.service';
import { MenuCommand } from '../../../../shared/models/menu-command';
import { MatCard, MatCardHeader, MatCardAvatar, MatCardTitle } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { MatNavList, MatListItem } from '@angular/material/list';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'lfw-user-bottom-sheet',
  templateUrl: './user-bottom-sheet.component.html',
  styleUrls: ['./user-bottom-sheet.component.css'],
  imports: [MatCard, MatCardHeader, MatCardAvatar, MatIcon, MatCardTitle, MatNavList, MatListItem, RouterLink]
})
export class UserBottomSheetComponent {
  userName = '';
  cmdSettings?: MenuCommand;
  cmdSignOff?: MenuCommand;

  public menuService = inject(MenuService);
  private readonly bottomSheetRef = inject(MatBottomSheetRef<UserBottomSheetComponent>);
  private readonly userInformationService = inject(UserInformationService);

  constructor() {
    const userInfo = this.userInformationService.userInformation;
    if (!userInfo.isEmpty) {
      this.userName = userInfo.displayName;
    }

    this.cmdSettings = this.menuService.cmdSettings;
    this.cmdSignOff = this.menuService.cmdSignOff;
  }

  get cmdCustomHelp(): MenuCommand | undefined {
    return this.menuService.cmdCustomHelp;
  }
  get cmdDefaultHelp(): MenuCommand | undefined {
    return this.menuService.cmdDefaultHelp;
  }
  get cmdAbout(): MenuCommand | undefined {
    return this.menuService.cmdAbout;
  }

  hasDefaultHelp(): boolean {
    return this.cmdDefaultHelp != null;
  }

  hasCustomHelp(): boolean {
    return this.cmdCustomHelp != null;
  }

  hasAbout(): boolean {
    return this.cmdAbout != null;
  }

  openLink(event: MouseEvent): void {
    this.bottomSheetRef.dismiss();
    event.preventDefault();
  }

  openHelp(cmd: MenuCommand | undefined): void {
    this.bottomSheetRef.dismiss();
    if (cmd) {
      window.open(cmd.route, '_blank');
    }
  }
}
